export type TppHistory = {
    status: string;
    modifiedDate: string;
}

export const DefaultTppHistory: TppHistory = {
    status: "",
    modifiedDate: ""
}
